import { KameleonBase } from "./kameleon-base";
import { themeColor } from "./theme-helper";

export * from "./base";

export const Wireframe: typeof KameleonBase & any = () => ({
  fonts: {
    heading: "Flow Circular, system-ui",
    body: "Flow Circular, system-ui",
  },
  fontSizes: [
    "0.75rem",
    "0.875rem",
    "1rem",
    "1.125rem",
    "1.25rem",
    "1.5rem",
    "1.75rem",
    "2rem",
    "2.25rem",
    "2.5rem",
    "2.75rem",
    "3rem",
    "3.25rem",
    "3.5rem",
    "3.75rem",
    "4rem",
    "4.5rem",
    "5rem",
    "5.25rem",
    "5.5rem",
    "7.5rem",
    "10rem",
  ],
  colors: {
    variables: {
      _neutral: "#E0E0E0", // Middelgrijs
      _mainCTA: "#BDBDBD", // Lichtgrijs, geschikt voor hoofd CTA-knoppen
      _secondaryCTA: "#9E9E9E", // Iets donkerder grijs voor secundaire CTA's
      _dark: "#757575", // Donkergrijs voor belangrijke tekst of elementen
      _darkest: "#424242", // Bijna zwart grijs voor de meest prominente visuele elementen
      _neutralLight: "#F5F5F5", // Zeer lichtgrijs, bijna wit, voor achtergronden en velden
    },
    modes: {
      dark: {},
      glow: `color-mix(in srgb, ${themeColor(
        "variables._mainCTA"
      )}, transparent 60%)`,
    },
  },
});
